<template>
  <div class="page">
    <!-- 头部 -->
    <AboutHeader></AboutHeader>
    <!-- 内容 -->
    <div class="content">
      <div class="jobs_box">
        <div class="jobs_title">文案策划</div>
        <div class="line"></div>
        <div class="jobs_content">
          <span>岗位职责</span>
          <p>1、负责公司对外各类公务行文管理及编撰，及公司对外各类资质申办、资金或政策扶持申请及申请资料编写； </p>
          <p>2、负责公司相关各类政策、行业报告、行业动态收集、解读，并有效的开展公司业务宣传工作； </p>
          <p>3、完成总经理交办的临时工作。</p>
          <div class="margin20"></div>
          <span>任职要求</span>
          <p>1、本科以上学历，3-5年工作经验，中文、新闻、媒体传播或工商管理相关专业； </p>
          <p>2、具有it相关行业从业经验； </p>
          <p>3、熟练掌握政府行文，善于公文或报告编撰，熟知大数据、软件相关行业，独立负责过各类政策扶持、专项资金申请或公司各类资质申请并能独立完成申请材料编写者优先；</p>
          <p>4、有较强的文字功底和理解领悟能力，独立负责过产品或项目宣传策划者优先，或在公众媒体或相关期刊发表过署名文章者优先。</p>
        </div>
      </div>
      <div class="jobs_box">
        <div class="jobs_title">文案策划</div>
        <div class="line"></div>
        <div class="jobs_content">
          <span>岗位职责</span>
          <p>1、负责公司对外各类公务行文管理及编撰，及公司对外各类资质申办、资金或政策扶持申请及申请资料编写； </p>
          <p>2、负责公司相关各类政策、行业报告、行业动态收集、解读，并有效的开展公司业务宣传工作； </p>
          <p>3、完成总经理交办的临时工作。</p>
          <div class="margin20"></div>
          <span>任职要求</span>
          <p>1、本科以上学历，3-5年工作经验，中文、新闻、媒体传播或工商管理相关专业； </p>
          <p>2、具有it相关行业从业经验； </p>
          <p>3、熟练掌握政府行文，善于公文或报告编撰，熟知大数据、软件相关行业，独立负责过各类政策扶持、专项资金申请或公司各类资质申请并能独立完成申请材料编写者优先；</p>
          <p>4、有较强的文字功底和理解领悟能力，独立负责过产品或项目宣传策划者优先，或在公众媒体或相关期刊发表过署名文章者优先。</p>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import AboutHeader from "@/components/page/AboutHeader.vue";
export default {
  components: {
    Footer,
    AboutHeader
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style scoped>
.page .content {
  width: 100%;
  margin-top: 150px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 100px;
}
.page .content .jobs_box {
  height: auto;
  border: 1px solid #dddddd;
  font-size: 24px;
  padding: 20px 30px;
  box-sizing: border-box;
  line-height: 40px;
  margin-bottom: 30px;
}
.page .content .jobs_box .jobs_title {
  font-size: 32px;
  color: #222222;
  font-weight: bold;
}
.page .content .jobs_box .line {
  width: 100%;
  height: 1px;
  background: #dddddd;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.page .content .jobs_box .jobs_content span {
  font-size: 28px;
  color: #222222;
}
.page .content .jobs_box .jobs_content .margin20 {
  margin-top: 40px;
}


</style>